import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: 'currentCategoryId',
  initialState,
  reducers: {
    setCurrentCategoryId(state, action: PayloadAction<string | null>) {
      return action.payload || initialState;
    },
  },
});

export const { setCurrentCategoryId } = slice.actions;

export default slice.reducer;
